import useIsNarrowerThan from '@liveauctioneers/caterwaul-components/lib/hooks/useIsNarrowerThan';

import { useAppSelector } from '@/redux/hooks';
import { getInitialWidth } from '@/redux/modules/windowSize';

const useIsNarrowerThanCustom: typeof useIsNarrowerThan = (width, initialSSRWidth) => {
    const initialWidth = useAppSelector(getInitialWidth);

    return useIsNarrowerThan(width, initialSSRWidth || initialWidth);
};

export default useIsNarrowerThanCustom;
